<template>
    <svg viewBox="0 0 354.254 354.254">
        <g>
            <path style="fill:#0088C3;" d="M122.911,239.37c-33.524-14.109-68.189-28.699-96.584-50.708   c-10.113-7.839-18.883-16.254-26.327-25.215v105.672c2.648-0.339,5.341-0.533,8.081-0.533c34.856,0,63.112,28.256,63.112,63.112   c0,7.95-1.484,15.549-4.167,22.555h109.416c10.01-3.152,19.117-7.561,25.889-13.665c5.73-5.164,12.307-13.505,12.307-32.322   C214.639,280.965,185.264,265.612,122.911,239.37z" />
            <path style="fill:#0088C3;" d="M317.622,0h-37.251c1.719,1.73,3.221,3.289,4.523,4.668c14.255,11.571,23.371,29.227,23.371,49.018   c0,34.856-28.256,63.112-63.113,63.112c-34.856,0-63.112-28.257-63.112-63.112c0-5.433,0.687-10.704,1.978-15.734   c-15.236-10.093-32.777-18.346-48.954-18.346c-13.266,0-34.781,3.89-51.757,14.853C67.196,44.867,60.01,58.104,60.01,77.384   c0,33.306,31.429,50.179,98.14,78.256c32.105,13.512,65.302,27.484,92.213,47.91c36.574,27.761,55.119,62.993,55.119,104.717   c0,16.374-2.414,31.785-7.131,45.987h19.271c20.23,0,36.631-16.4,36.631-36.63V36.631C354.254,16.4,337.854,0,317.622,0z" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'Scribd'
}
</script>
